import RedesignPageLayout from '../components/common/RedesignPageLayout';
import BlogRequest from '../components/blog-request/BlogRequest';

export default function BlogRequestPage() {
    return (
        <RedesignPageLayout>
            <BlogRequest />
        </RedesignPageLayout>
    );
}
